import React, { useContext, useState, useEffect } from 'react';
import './Profile.css'; 
import { FaPen, FaSignOutAlt } from 'react-icons/fa'; 
import { UserContext } from './UserContext';
import Notiflix from "notiflix";
import { endpoint } from "./endpoint";

const Profile = () => {
    const { user, updateUser, logout, isLoading } = useContext(UserContext);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({});
    const [originalPhone, setOriginalPhone] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [isVerifying, setIsVerifying] = useState(false);
    const [isVerifyingLoading, setIsVerifyingLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData(user); // Sync formData with user data
            setOriginalPhone(user.phone);
        }
    }, [user]);

    const handleEditToggle = () => {
        setEditMode(!editMode);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        if (!formData.name || !formData.surname || !formData.phone) {
            Notiflix.Report.warning('Please fill in all required fields.');
            return false;
        }
        return true;
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        if (formData.phone !== originalPhone) {
            Notiflix.Notify.info('Phone number changed. Verification is required.');
            try {
                const response = await fetch(`${endpoint}/gymapp/sendCode.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ phone: formData.phone }),
                });

                const result = await response.json();

                if (result.status === 'success') {
                    Notiflix.Notify.success(result.message || 'Verification code sent to your new phone number.');
                    setIsVerifying(true);
                } else {
                    Notiflix.Report.failure(result.message || 'Failed to send verification code.');
                }
            } catch (error) {
                Notiflix.Report.failure('An error occurred while sending verification code. Please try again.');
            }
        } else {
            updateUser(formData);
            setEditMode(false); // Exit edit mode after saving
        }
    };

    const handleVerify = async () => {
        if (!verificationCode) {
            Notiflix.Report.warning('Please enter the verification code.');
            return;
        }

        setIsVerifyingLoading(true);
        try {
            const response = await fetch(`${endpoint}/gymapp/verify.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    phone: formData.phone,
                    code: verificationCode,
                }),
            });

            const result = await response.json();

            if (result.status === 'success') {
                Notiflix.Notify.success('Phone number verified successfully.');
                updateUser(formData);
                setEditMode(false); // Exit edit mode after verification
                setIsVerifying(false);
            } else {
                Notiflix.Report.failure(result.message || 'Verification failed. Please try again.');
            }
        } catch (error) {
            Notiflix.Report.failure('An error occurred during verification. Please try again.');
        } finally {
            setIsVerifyingLoading(false);
        }
    };

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <div className="profile-container">
            <br /><br /><br />
            <div className="profile-header">
                <h2>Profile</h2>
                <FaPen className="edit-icon" onClick={handleEditToggle} title="Edit Profile" />
            </div>
            <div className="profile-info">
                <div>
                    <label>Name:</label>
                    {editMode ? (
                        <input 
                            className="form-control"
                            type="text" 
                            name="name" 
                            value={formData.name || ''} 
                            onChange={handleChange} 
                        />
                    ) : (
                        <p>{user.name}</p>
                    )}
                </div>
                <div>
                    <label>Surname:</label>
                    {editMode ? (
                        <input 
                            className="form-control"
                            type="text" 
                            name="surname" 
                            value={formData.surname || ''} 
                            onChange={handleChange} 
                        />
                    ) : (
                        <p>{user.surname}</p>
                    )}
                </div>
                <div>
                    <label>Email:</label>
                    <p>{user.email}</p>
                </div>
                <div>
                    <label>Phone:</label>
                    {editMode ? (
                        <input
                            className="form-control"
                            type="text" 
                            name="phone" 
                            value={formData.phone || ''} 
                            onChange={handleChange} 
                        />
                    ) : (
                        <p>{user.phone}</p>
                    )}
                </div>
            </div>

            <div className="profile-actions">
                {editMode && (
                    <button onClick={handleSave} disabled={isLoading}>
                        {isLoading ? 'Saving...' : 'Save'}
                    </button>
                )}
            </div>
            <button className="logout-button" onClick={logout}>
                <FaSignOutAlt /> Logout
            </button>

            {isVerifying && (
                <div className="overlay">
                    <div className="overlay-content">
                        <h3>Verify Your Phone Number</h3>
                        <label>Enter Verification Code:</label>
                        <input 
                            className="form-control"
                            type="text" 
                            value={verificationCode} 
                            onChange={(e) => setVerificationCode(e.target.value)} 
                        />
                        <div className="overlay-buttons">
                            <button onClick={handleVerify} disabled={isVerifyingLoading}>
                                {isVerifyingLoading ? 'Verifying...' : 'Verify'}
                            </button>
                            <button style={{ marginLeft: "5px" }} className="btn btn-danger" onClick={() => setIsVerifying(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Profile;
